module.exports = __webpack_public_path__ + "img/og.0dcb5a7e.png";